import React from 'react';

const Services: React.FC = () => {
  return (
    <section id="servicios" className="services">
      <div className="services-container">
        <h2 className="section-title">Nuestros Servicios</h2>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">🔧</div>
            <h3>Mantenimiento Especializado</h3>
            <p>
              Contamos con la experiencia necesaria para brindar mantenimiento 
              y reparación a equipos médicos en general de cualquier marca. Nuestro equipo 
              técnico especializado garantiza el óptimo funcionamiento de sus equipos hospitalarios.
            </p>
          </div>
          
          <div className="service-card">
            <div className="service-icon">⚕️</div>
            <h3>Equipos Hospitalarios</h3>
            <p>
              Especialistas en mantenimiento de equipo hospitalario con años de 
              experiencia en el sector. Ofrecemos servicios técnicos profesionales 
              para garantizar la operatividad de sus instalaciones médicas.
            </p>
          </div>
          
          <div className="service-card">
            <div className="service-icon">🛡️</div>
            <h3>Soporte Técnico</h3>
            <p>
              Brindamos soporte técnico especializado y asesoría profesional 
              para el mantenimiento preventivo y correctivo de equipos médicos, 
              asegurando su funcionamiento óptimo y prolongando su vida útil.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
